module.exports = __webpack_public_path__ + "img/imageclose.aca6e9d6.svg";